<template>
  <div class="body">
    <h2>Change Password</h2>
    <form @submit.prevent="changePassword" ref="loginform">


          <div v-if="error" style="color:red">{{ error }}</div>
          <div v-if="success" style="color:green">{{ success }}</div>
          <br/>
          <div class="form-group">
            <label for="password">Password</label>
            <div class="password-input-container">
              <input v-model="password" :type="showPasswordConfirmation ? 'text' : 'password'" id="password" name="password" autocomplete="current-password" class="password-input" />
              <a href="#" class="toggle-password" @click.prevent="togglePasswordVisibility('passwordConfirmation')">
                {{ showPassword ? 'Hide' : 'Show' }}
              </a>
            </div>
          </div>

          <div class="form-group">
            <label for="password">Confirm Password</label>
            <div class="password-input-container">
              <input v-model="passwordConfirmation" :type="showPasswordConfirmation ? 'text' : 'password'" id="password" name="passwordConfirmation" autocomplete="current-password" class="password-input"/>
              <a href="#" class="toggle-password" @click.prevent="togglePasswordVisibility('passwordConfirmation')">
                {{ showPassword ? 'Hide' : 'Show' }}
              </a>
            </div>
          </div>
      <div class="actions">
        <button class="primary"   type="submit">Save</button>
        <button v-if="resetToken" :disabled="false" class="secondary" type="submit"  @click.prevent="cancel">Cancel</button> 
      </div>
    </form>
  </div>
</template>

<script>
import { router, isPasswordValid } from "../../common";
import UxMixin from "@/components/UxMixin.vue";
import {mapActions, mapState} from "vuex";
import {userInfo} from "@/common/user-info";

export default {
  name: "ChangePassword",
  props: ["resetToken"],
  data: function () {
    return {
      user_id: null,
      password: '',
      passwordConfirmation: '',
      error: '',
      success: '',
      showPassword: false,
      showPasswordConfirmation: false,
      //status: { loggingIn: false, error: false},
      screenWidth: window.innerWidth
    };
  },

  mixins: [UxMixin],
  computed: {
    ...mapState("user", ["usersById", "status"]),
    currentUser() {
      return this.usersById[this.user_id];
    },
    passwordError() {
      return !isPasswordValid(this.password)
    },
    passwordConfirmationError() {
      return this.passwordConfirmation !== this.password
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions("user", ["changeUserPassword", "resetPassword", "clearUsersState"]),     
    async changePassword() {
      // Everything renders in-page: window.alert() fired after an await is
      // unreliable in the iOS webview, and silent failures here produced a
      // long-standing "dead reset screen" mystery.
      try {
        if (this.passwordError || this.passwordConfirmationError) {
          this.error = 'Passwords must match and be at least 8 characters long, contain a number, a lowercase letter, an uppercase letter, and a symbol'
          return
        }
        this.error = ''
        this.success = ''
        if (this.resetToken){
            // Emailed prt values arrive as compound strings
            // ("<token>/1/<tracking>/<sig>"); RAS wants only the first
            // segment — same normalization the router's web guard applies.
            const token = String(this.resetToken).split('/')[0]
            await this.resetPassword({ token: token, password: this.password });
            if (this.status.error){
              this.error = 'We could not reset your password — the link may have expired. Please request a new reset email.'
              this.clearUsersState()
            } else {
              // Let the confirmation actually be seen before redirecting —
              // an instant push reads as an unexplained jump to login.
              this.success = 'Password changed! Taking you to log in…'
              setTimeout(() => router.push("/login"), 1500)
            }
        } else if (this.currentUser) {
          this.changeUserPassword({updatedUser: this.currentUser, password: this.password})
          this.$emit('saveComplete');
          this.$store.dispatch('user/flashSuccess', 'Password successfully updated!');
        } else {
          // No reset token and no logged-in user: previously a silent
          // no-op (the original dead screen). Reached when the deep link
          // loses the prt param, e.g. cold-start launches.
          this.error = 'This reset link is missing its security code. Please open the link from your reset email again, or request a new one.'
        }
      } catch (e) {
        console.error('changePassword failed', e)
        this.error = 'Something went wrong saving your password. Please try again or request a new reset email.'
      }
    },
    async loadPageData() {
      this.user_id = userInfo()?.user_id;
    },
    togglePasswordVisibility(field) {
      if (field === 'password') {
        this.showPassword = !this.showPassword
      } else if (field === 'passwordConfirmation') {
        this.showPasswordConfirmation = !this.showPasswordConfirmation
      }
    },
    cancel() {
      router.push("/login");
    },
    scrollBack(){
      this.$refs["loginform"].style = ''
    },
    scrollTop(){
      console.log(this.screenWidth)
      if (this.screenWidth < 960) {
      this.$refs["loginform"].style = 'position: fixed; top: 25px; width: 100%'
      }
    },
    scrollToTop () {
      this.$el.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  flex-grow: 1;
  padding-right: 60px; /* Adjust as needed for space for the toggle link */
}

.toggle-password {
  color: #008295;
  position: absolute;
  right: 10px; /* Adjust as needed for exact positioning */
  cursor: pointer;
  padding: 5px;
  text-decoration: none;
}
</style>